<div class="gallery">
  <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
    <div class="swiper-wrapper">
      @for (destination of destinations | slice: 0: 5; track destination.place_id; let idx = $index) {
        <div class="swiper-slide">

          <div class="gallery-card">
            <div class="gallery-card__header">
              <figure>
                <img [src]="destination?.imageUrl | safeUrl" alt="country-image">
              </figure>
            </div>
            <div class="gallery-card__content">
              <div class="gallery-card__row">
                <p class="gallery-card__description"
                   [innerHtml]="destination.name">
                </p>
              </div>
            </div>
          </div>

        </div>
      }
    </div>
    <div class="swiper-pagination"></div>
  </div>
</div>
